function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "lI9y";


//////////////////
// WEBPACK FOOTER
// ./src/page \.ru.js$
// module id = lI9y
// module chunks = 225